'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}
'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}
